import InternetIssue from "components/internet-issue/internet-issue";
export default InternetIssue;
